/*eslint-disable */
import React, { Component } from "react";
import Loader from "react-loader-spinner";
import ReactTooltip from "react-tooltip";
import EditAssetProfilerFormModal from "./ApproveOrDeclineReview";
import CommentForm from "./CommentForm";
// import PureModal from 'react-pure-modal';
// import 'react-pure-modal/dist/react-pure-modal.min.css';
import ButtonLoader from "../../assets/svg/loading.svg";
import moment from "moment";
import FormSearchInput from "../inputs/FormSearchInput";
import TextInput from "../inputs/TextInput";
import SelectInput from "../inputs/SelectInput";
import Select from "react-select";
import {
  Post,
  Get,
  Delete,
  Put,
  GetwithQueryString,
} from "../../utility/fetch";
import { URLAPI } from "../../utility/ApiMethods";
import { GiTrashCan } from "react-icons/gi";
import { ImCheckmark, ImCancelCircle, ImEye } from "react-icons/im";
import { GrEdit } from "react-icons/gr";
import data from "../../data";
import { GiRecycle } from "react-icons/gi";
import Cookies from "js-cookie";
import {
  deleteMessage,
  errorMessage,
  successMessage,
} from "../../resources/alert";
import LoadingSpinner from "../../resources/loadingSpinner";

import ViewProfilerDetails from "./ViewProfilerDetails";

const bottomBorder = {
  borderBottom: ".5px solid rgba(99,99,99,.6)",
};
const tableBorder = {
  border: "none",
  borderRight: "1px solid #0000000A",
  borderBottom: "1px solid #0000000A",
};

class ApproveOrDeclineReview extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      approvalId: "",
      sequence: "",
      button: "Save Record",
      records: [],
      employees: [],
      employee: 0,
      employeeName: "",
      bgColor: "",
      requestId: 0,
      approval: [],
      loading: false,
      bgColor: "white",
      loadTable: false,
      loadForm: false,
      category: "Request",
      sequence: 0,
      roleId: 0,
      visibility: false,
      type: "",
      visibleDetails: false,
    };
    // this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleEmpOption = (approvalId) => {
    this.setState({ approvalId }, () =>
      console.log("option selected", this.state.approvalId)
    );
  };

  getEmployee = (data) => {
    if (this._isMounted) {
      let _records = Array.isArray(data) ? data : [];

      this.setState({ employees: _records, loading: false });
    }
  };

  getApproval = (data) => {
    if (this._isMounted) {
      let _records = Array.isArray(data) ? data : [];

      this.setState({ approval: _records, loadTable: false });
    }
  };

  getRoleList = (data) => {
    this.setState({
      employees: data,
    });
  };

  componentDidMount() {
    this.setState({ loadTable: true });
    this._isMounted = true;
    try {
      Get(URLAPI.profiler.GetApprovalPending, this.getApprovalPendingList);
    } catch (err) {
      this.setState({ loadTable: false });
    }
  }

  getApprovalPendingList = (data) => {
    if (this._isMounted) {
      let _records = Array.isArray(data) ? data : [];
      this.props.recordProfilerLength({ len: _records.length, loading: false });

      this.setState({ approval: _records, loadTable: false });
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  validateForm = () => {
    const { sequence, roleId } = this.state;

    if (!roleId) return { status: true, message: "Please, Select a role" };
    if (!sequence)
      return { status: true, message: "Please, Enter Approval Sequence" };
    return false;
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({
      loadTable: true,
      loadForm: true,
    });

    const { sequence, roleId, category, id } = this.state;

    let error_data = this.validateForm();

    if (error_data.status && error_data.status === true) {
      this.setState({
        loadTable: false,
        loadForm: false,
      });
      return errorMessage(error_data.message);
    }
    if (error_data === false) {
      let request;

      if (this.state.button === "Save Record") {
        request = {
          roleId: Number(roleId),
          category,
          sequence: Number(sequence),
        };
        this.onSubmitSave(request);
      } else if (this.state.button === "Update") {
        request = {
          id,
          roleId: Number(roleId),
          category,
          sequence: Number(sequence),
        };
        this.onSubmitUpdate(request);
      }
    }
  };

  onSubmitSave = (data) => {
    Post(data, URLAPI.approval.Post, this.onSubmitAfterSave);
  };

  onSubmitAfterSave = (data) => {
    if (data.code === 1) {
      successMessage(data.message);

      Get(
        URLAPI.approval.GetApprovalList + "/" + this.state.category,
        this.getApproval
      );

      this.setState({
        roleId: 0,
        role: "",
        sequence: 0,
        loadForm: false,
      });
    }
    if (data.code === 0) {
      this.setState({
        roleId: 0,
        role: "",
        sequence: 0,
        loadTable: false,
        loadForm: false,
      });
      errorMessage(data.message);
    }
  };

  handleDeleteRecord(record) {
    deleteMessage(() => this.onDelete(record));
  }

  onDelete = (record) => {
    this.setState({ loadTable: true });
    Delete(URLAPI.approval.Delete + "/" + record.id, this.onAfterDelete);
  };

  onAfterDelete = (res) => {
    if (res.code === 1) {
      Get(
        URLAPI.approval.GetApprovalList + "/" + this.state.category,
        this.getApproval
      );
      successMessage(res.message);

      this.setState({ loadTable: false });
    } else if (res.code === 1) {
      this.setState({ loadTable: false, visible: false });
      errorMessage(res.message);
    } else {
      this.setState({ loadTable: false });
      errorMessage(res.message);
    }
  };

  onEdit = (item) => {
    if (item) {
      const { roleId, sequence, id, role } = item;
      this.setState({
        roleId,
        id,
        button: "Update",
        sequence,
        role,
        bgColor: "#c2f542",
      });
    }
  };

  onSubmitUpdate = (request) => {
    if (request.itemCategoryId !== 0) {
      Put(
        request,
        `${URLAPI.approval.Put}/${request.id}`,
        this.onSubmitAfterUpdate
      );
    }
  };

  onSubmitAfterUpdate = (data) => {
    if (data.code === 1) {
      successMessage(data.message);
      this.setState({ loadTable: true });
      Get(
        URLAPI.approval.GetApprovalList + "/" + this.state.category,
        this.getApproval
      );
      //commit to state
      this.setState({
        selectedRole: "",
        roleId: 0,
        sequence: 0,
        button: "Save Record",
        loadForm: false,
        bgColor: "white",
      });

      //this.handleCancel();
    } else if (data.code === 0) {
      this.setState({
        loadTable: false,
        loadForm: false,
        button: "Save Record",
        bgColor: "white",
      });
      errorMessage(data.message);
    } else {
      errorMessage(
        "Something went wrong while trying to update record Please, try again later."
      );
      this.setState({
        loadTable: false,
        loadForm: false,
        button: "Save Record",
        bgColor: "white",
      });
    }
  };

  handleClear = () => {
    //clear all action
    this.setState({
      sequence: 0,
      role: "",
      button: "Save Record",
      bgColor: "white",
    });
  };

  handleStateChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleAction = (comment) => {
    this.setState({
      validationStatus: "",
      validationCode: 0,
      loading: true,
    });
    if (!comment) {
      return this.setState({
        validationStatus: "Comment cannot be empty",
        validationCode: 0,
        loading: false,
      });
    }
    Put(
      {
        id: this.state.id,
        action: this.state.type,
        comment,
      },
      URLAPI.profiler.ApproveOrDecline,
      this.afterAction
    );
  };

  afterAction = (response) => {
    if (response.code === 1) {
      this.setState({
        loadTable: true,
      });
      Get(URLAPI.profiler.GetApprovalPending, this.getApprovalPendingList);
      this.setState({
        visibility: false,
        loading: false,
      });

      successMessage(response.message);
    } else {
      this.setState({
        visibility: false,
        loading: false,
      });
      errorMessage(response.message);
    }
  };

  render() {
    const { sequence, button, loading, loadTable, loadForm, visibleDetails } =
      this.state;
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div
              id="bordered-table"
              className="table-view "
              style={{
                borderCollapse: "collapse",
                borderSpacing: "25px 15px",
                marginLeft: 10,
                // marginRight: 10,
                // border: 'none',
                ...this.props.overrideTableStyles,
              }}
            >
              <div
                className="table-header"
                style={{
                  backgroundColor: `${this.props.headerBGColor || "#F0F0F0"}`,
                  color: `${this.props.headerColor || "#43425D"}`,
                }}
              >
                <div className="table-row">
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Name</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Entered By</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Supplier</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Manufacturer</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Asset Value</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Quantity</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Serial Number</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Actions</p>
                  </div>
                </div>
              </div>

              {loadTable ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContents: "center",
                  }}
                >
                  <Loader
                    type="ThreeDots"
                    color="green"
                    height={80}
                    width={80}
                  />
                </div>
              ) : (
                <>
                  {this.state.approval.length === 0 ? (
                    <div style={{ marginLeft: 10 }}>
                      <br />
                      <h3>No Pending Asset Entries</h3>
                    </div>
                  ) : (
                    <div className="table-body no-border">
                      {this.state.approval.map((item, i) => (
                        <div className="table-row no-border" key={item.id}>
                          <div
                            className="td font-sz-13"
                            style={{
                              ...tableBorder,
                            }}
                          >
                            {item.itemName || "empty name"}
                          </div>
                          <div
                            className="td font-sz-13"
                            style={{ ...tableBorder }}
                          >
                            {item.profiledBy || "empty Entered By"}
                          </div>
                          <div
                            className="td font-sz-13"
                            style={{ ...tableBorder }}
                          >
                            {item.supplier || "empty supplier"}
                          </div>
                          <div
                            className="td font-sz-13"
                            style={{ ...tableBorder }}
                          >
                            {item.manufacturer || "empty manufacturer"}
                          </div>

                          <div
                            className="td font-sz-13"
                            style={{ ...tableBorder }}
                          >
                            &#8358;{item.unitCost || "empty unit cost"}
                          </div>
                          <div
                            className="td font-sz-13"
                            style={{ ...tableBorder }}
                          >
                            {item.quantity || "empty quantity"}
                          </div>
                          <div
                            className="td font-sz-13"
                            style={{ ...tableBorder }}
                          >
                            {item.serialNumber || "empty quantity"}
                          </div>

                          <div
                            className="td m-l-10 font-sz-22 pointer"
                            style={{ ...tableBorder }}
                          >
                            {button === "Update" || loadForm ? null : (
                              <>
                                <button
                                  // className='btn edit-btn'
                                  // style={{

                                  //   borderColor: 'black',
                                  //   borderWidth: 10
                                  // }}
                                  data-tip
                                  data-for="view-details"
                                  type="button"
                                  className="pointer td actions"
                                  onClick={() =>
                                    this.setState({
                                      visibleDetails: true,
                                      profiledBy: item.profiledBy,
                                      itemName: item.itemName,
                                      description: item.description,
                                      supplier: item.supplier,
                                      manufacturer: item.manufacturer,
                                      deliveryDate: item.deliveryDate,
                                      unitCost: item.unitCost,
                                      totalCost: item.totalCost,
                                      serialNumber: item.serialNumber,
                                      category: item.category,
                                      quantity: item.quantity,
                                      supportingDoc: item.supportingDoc,
                                      approvers: item.approvers,
                                      lastUpdated: item.lastUpdated,
                                    })
                                  }
                                >
                                  <ImEye />
                                </button>
                                <ReactTooltip
                                  id="view-details"
                                  type="success"
                                  effect="solid"
                                >
                                  <span>View Details</span>
                                </ReactTooltip>
                                {"                   "}
                                <button
                                  data-tip
                                  data-for="edit-btn"
                                  type="button"
                                  className="pointer td actions"
                                  onClick={() =>
                                    this.setState({
                                      visibility: true,
                                      id: item.id,
                                      type: 1,
                                      itemName: item.itemName,
                                    })
                                  }
                                >
                                  <ImCheckmark />
                                </button>
                                <ReactTooltip
                                  id="edit-btn"
                                  type="warning"
                                  effect="solid"
                                >
                                  <span>Approve Asset Entry</span>
                                </ReactTooltip>

                                <button
                                  data-tip
                                  data-for="del-btn"
                                  type="button"
                                  className="m-l-10 del pointer td actions"
                                  onClick={() =>
                                    this.setState({
                                      visibility: true,
                                      id: item.id,
                                      type: 0,
                                      itemName: item.itemName,
                                    })
                                  }
                                >
                                  <ImCancelCircle />
                                </button>
                                <ReactTooltip
                                  id="del-btn"
                                  type="error"
                                  effect="solid"
                                >
                                  <span>Decline Asset Entry</span>
                                </ReactTooltip>
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {this.state.visibility && (
          <CommentForm
            onEnterAction={this.handleAction}
            loading={this.state.loading}
            type={this.state.type}
            itemName={this.state.itemName}
            validationStatus={this.state.validationStatus}
            validationCode={this.state.validationCode}
            closeModal={() =>
              this.setState({ visibility: !this.state.visibility })
            }
          />
        )}

        {visibleDetails && (
          <ViewProfilerDetails
            profiledBy={this.state.profiledBy}
            itemName={this.state.itemName}
            description={this.state.description}
            supplier={this.state.supplier}
            manufacturer={this.state.manufacturer}
            deliveryDate={this.state.deliveryDate}
            unitCost={this.state.unitCost}
            totalCost={this.state.totalCost}
            serialNumber={this.state.serialNumber}
            category={this.state.category}
            quantity={this.state.quantity}
            supportingDoc={this.state.supportingDoc}
            approvers={this.state.approvers}
            lastUpdated={this.state.lastUpdated}
            closeModal={() => this.setState({ visibleDetails: false })}
          />
        )}
      </>
    );
  }
}

export default ApproveOrDeclineReview;
